import {
  selectEditingCollection,
  setSelectedMenu,
  setSelectedMenuId,
} from "../../redux/features/appData";
import "./SnippetManagerZero.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MENUS } from "../config/menus";
import { useSelector } from "react-redux";

type SnippetManagerZeroProps = {};

export const SnippetManagerZero = ({}: SnippetManagerZeroProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentCollection = useSelector(selectEditingCollection);

  return (
    <div className="snippet-manager-zero">
      <div className="snippet-manager-zero-header">
        No quick replies yet. Ask a question to create your first one.
      </div>

      <div className="snippet-manager-zero-icon">
        <button
          onClick={() => {
            dispatch(setSelectedMenu(MENUS.COLLECTION_ASK));
            dispatch(setSelectedMenuId(null));
            navigate("/collection/" + currentCollection?.id);
          }}>
          Ask a Question
        </button>
      </div>
    </div>
  );
};
